import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import './mesh-gradient-background.css';

interface GradientOrb {
  id: number;
  size: number;
  x: number;
  y: number;
  color1: string;
  color2: string;
  duration: number;
  delay: number;
}

export const MeshGradientBackground: React.FC = () => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const springConfig = { stiffness: 50, damping: 30 };
  const _smoothMouseX = useSpring(mouseX, springConfig);
  const _smoothMouseY = useSpring(mouseY, springConfig);

  const orbs: GradientOrb[] = [
    { id: 1, size: 600, x: 10, y: 10, color1: '#667eea', color2: '#764ba2', duration: 20, delay: 0 },
    { id: 2, size: 500, x: 70, y: 20, color1: '#f093fb', color2: '#f5576c', duration: 25, delay: 2 },
    { id: 3, size: 550, x: 20, y: 70, color1: '#4facfe', color2: '#00f2fe', duration: 22, delay: 4 },
    { id: 4, size: 450, x: 80, y: 60, color1: '#43e97b', color2: '#38f9d7', duration: 18, delay: 1 },
    { id: 5, size: 400, x: 50, y: 40, color1: '#fa709a', color2: '#fee140', duration: 24, delay: 3 },
    { id: 6, size: 480, x: 30, y: 50, color1: '#30cfd0', color2: '#330867', duration: 21, delay: 5 },
    { id: 7, size: 420, x: 60, y: 80, color1: '#a8edea', color2: '#fed6e3', duration: 19, delay: 2.5 },
    { id: 8, size: 520, x: 40, y: 30, color1: '#ff9a9e', color2: '#fecfef', duration: 23, delay: 1.5 },
  ];

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [mouseX, mouseY]);

  return (
    <div className="mesh-gradient-background">
      {orbs.map((orb) => (
        <motion.div
          key={orb.id}
          className="gradient-orb"
          style={{
            width: orb.size,
            height: orb.size,
            left: `${orb.x}%`,
            top: `${orb.y}%`,
            background: `radial-gradient(circle at center, ${orb.color1}, ${orb.color2})`,
          }}
          animate={{
            x: ['-20%', '20%', '-20%'],
            y: ['-20%', '20%', '-20%'],
            scale: [1, 1.1, 1],
            opacity: [0.15, 0.25, 0.15],
          }}
          transition={{
            duration: orb.duration,
            delay: orb.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}

      {/* Overlay for depth */}
      <div className="mesh-gradient-overlay" />
    </div>
  );
};
